import { useEventCallback } from '@cian/react-utils';
import { useMemo, useState } from 'react';
import { trackPanoramaOpen } from '../tracking';

export const usePanoramaModal = () => {
  const [panoramaOpened, setPanoramaOpened] = useState(false);

  const closePanorama = useEventCallback(() => {
    setPanoramaOpened(false);
  });

  const openPanorama = useEventCallback(() => {
    setPanoramaOpened(true);
    trackPanoramaOpen();
  });

  return useMemo(
    () => ({ panoramaOpened, openPanorama, closePanorama }),
    [closePanorama, openPanorama, panoramaOpened],
  );
};
